
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompensationCurrentUserShow"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"draftCompensations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"year"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"experience"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"industry"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fundType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fundStrategy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fundSize"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetClass"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baseSalary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interestMgmtFeesPerc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interestMgmtFeesValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vestingMgmtFees"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interestIncentiveFeesPerc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interestIncentiveFeesValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vestingIncentiveFees"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"annualDiscrBonus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalDeferredComp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"investInFund"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"buildPersonalTrackRecord"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marketPersonalTrackRecord"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":615}};
    doc.loc.source = {"body":"query CompensationCurrentUserShow {\n  currentUser {\n    id\n    draftCompensations {\n      id\n      status\n      category\n      year\n      title\n      experience\n      industry\n      location\n      fundType\n      fundStrategy\n      fundSize\n      assetClass\n      baseSalary\n      interestMgmtFeesPerc\n      interestMgmtFeesValue\n      vestingMgmtFees\n      interestIncentiveFeesPerc\n      interestIncentiveFeesValue\n      vestingIncentiveFees\n      annualDiscrBonus\n      totalDeferredComp\n      investInFund\n      buildPersonalTrackRecord\n      marketPersonalTrackRecord\n      comments\n      updatedAt\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CompensationCurrentUserShow"] = oneQuery(doc, "CompensationCurrentUserShow");
        
